import {
  chunkString,
  debounce,
  extractTextFromHTML,
} from '../../../shared/helpers.js'
import ariaAnnouncementManager from '../../../shared/Platform/WebOS/AriaAnnouncementManager'
import { store } from '../store'
class TTS {
  constructor() {
    this.textHolder = ''
    this.textHolderAtTheEnd = ''
    this.textHolderAtTheBegining = ''
  }

  debouncedSpeak = debounce((x) => {
    this.speak(
      `${
        this.textHolderAtTheBegining
          ? this.textHolderAtTheBegining + ' ...'
          : ''
      } ${x} ${
        this.textHolderAtTheEnd ? ' ... ' + this.textHolderAtTheEnd : ''
      }`
    )

    this.textHolderAtTheBegining = ''
    this.textHolderAtTheEnd = ''
  }, 500)

  debouncedStop = debounce(this.stop, 500)

  enqueueTextToRead(textToRead) {
    this.textHolderAtTheEnd += textToRead
  }
  pushTextToRead(textToRead) {
    this.textHolderAtTheBegining += textToRead
  }

  addTextToRead(textToRead) {
    if (!store.getState().device.ttsEnabled) return

    if ('string' === typeof textToRead) {
      //if long and on tizen, chunk and don't debounce.
      if (
        textToRead.length > 500 &&
        (COMPILING_FOR_TIZEN || COMPILING_FOR_COMCASTX1)
      ) {
        let chunks = chunkString(textToRead, 300)
        for (const chunk of chunks) {
          this.speak(chunk)
        }
      } else {
        this.debouncedSpeak(textToRead)
      }
    } else if (textToRead instanceof Array) {
      let stringsToSay = []
      for (let str of textToRead) {
        if ('string' === typeof str) {
          stringsToSay.push(str)
        }
      }

      stringsToSay = stringsToSay.filter((str) => str !== '')
      let text = stringsToSay.join(' ... ')
      if (
        text.length > 500 &&
        (COMPILING_FOR_TIZEN || COMPILING_FOR_COMCASTX1)
      ) {
        let chunks = chunkString(text, 300)
        for (let str of chunks) {
          this.speak(str)
        }
      } else {
        this.debouncedSpeak(text)
      }
    }
  }

  stopRead() {
    if (COMPILING_FOR_LGTV) {
      this.stop()
    } else {
      this.debouncedStop()
    }
  }

  clearPushedText() {
    this.textHolderAtTheBegining = ''
  }

  stop() {
    if (COMPILING_FOR_VIZIO) {
      try {
        window.VIZIO.Chromevox.play('🛑')
      } catch (error) {
        console.error(error)
      }
    } else if (COMPILING_FOR_LGTV) {
      ariaAnnouncementManager.clearContent()
    } else {
      window.speechSynthesis.cancel()
    }
  }

  speak(str) {
    str = extractTextFromHTML(str)
    str = str.replace(/\|/g, ' ')
    if (COMPILING_FOR_VIZIO) {
      try {
        str = str.replaceAll('(', '').replaceAll(')', '')
        window.VIZIO.Chromevox.play(str)
      } catch (error) {
        console.error(error)
      }
    } else if (COMPILING_FOR_LGTV) {
      ariaAnnouncementManager.announce(str)
    } else {
      window.speechSynthesis.speak(new SpeechSynthesisUtterance(str))
    }
  }
}

const tts = new TTS()

export default tts
